package com.dotdrives.web.ui

import react.FC
import react.PropsWithChildren
import react.ReactNode
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface DotListItemProps : PropsWithChildren {
    var title: String
    var subtitle: String?
    var leading: ReactNode?
    var trailing: ReactNode?
    var onClick: (() -> Unit)?
    var className: String?
}

private fun react.ChildrenBuilder.listItemContent(props: DotListItemProps) {
    props.leading?.let { leading ->
        div {
            className = ClassName("dot-list-leading")
            +leading
        }
    }
    div {
        className = ClassName("dot-list-copy")
        div {
            className = ClassName("dot-label")
            +props.title
        }
        props.subtitle?.let { subtitle ->
            div {
                className = ClassName("dot-list-subtitle dot-body")
                +subtitle
            }
        }
    }
    props.trailing?.let { trailing ->
        span {
            className = ClassName("dot-list-trailing")
            +trailing
        }
    }
}

val DotListItem = FC<DotListItemProps> { props ->
    val classes = listOfNotNull(
        "dot-list-item",
        "dot-list-item-clickable".takeIf { props.onClick != null },
        props.className,
    ).joinToString(" ")

    if (props.onClick != null) {
        button {
            type = ButtonType.buttonType
            className = ClassName(classes)
            onClick = { props.onClick?.invoke() }
            listItemContent(props)
        }
    } else {
        div {
            className = ClassName(classes)
            listItemContent(props)
        }
    }
}
